<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import AppToast from '@/components/AppToast.vue'
import PublicHeader from '@/components/PublicHeader.vue'
import StudioShell from '@/components/StudioShell.vue'

const route = useRoute()
const layout = computed(() => route.meta.layout ?? 'public')
</script>

<template>
  <div v-if="layout === 'studio'" class="app-root">
    <StudioShell>
      <RouterView :key="route.path" />
    </StudioShell>
  </div>
  <div v-else-if="layout === 'login'" class="app-root login-layout">
    <RouterView />
  </div>
  <div v-else class="app-root">
    <PublicHeader />
    <main class="public-main">
      <RouterView />
    </main>
    <footer class="public-footer">
      <span>以文字整理时间。</span>
      <RouterLink to="/studio/login">编辑部</RouterLink>
    </footer>
  </div>
  <AppToast />
</template>
